import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { ListagemSolicitacoes } from '../interfaces/listagem-solicitacoes';

@Injectable({
  providedIn: 'root'
})
export class ListagemSolicitacoesService {

  readonly url = `${environment.apiURL}/relatorio/listagem_solicitacoes`;

  constructor(private http: HttpClient) { }

  saveOrUpdate(relatorio: ListagemSolicitacoes): Observable<ListagemSolicitacoes> {
    return this.http.put<ListagemSolicitacoes>(`${this.url}`, relatorio);
  }

  getItem(id: number ): Observable<ListagemSolicitacoes> {
    return this.http.get<ListagemSolicitacoes>(`${this.url}/${id}`);
  }

  getItemPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<ListagemSolicitacoes>> {
    return this.http.get<PageResult<ListagemSolicitacoes>>(`${this.url}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getItemPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<ListagemSolicitacoes>> {
    return this.http.get<PageResult<ListagemSolicitacoes>>(`${this.url}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  printForm(controle: number , formId: number, onlyPrint = false): Observable<any> {
    return this.http.get(`${this.url}/print/${controle}/${formId}/${onlyPrint}`, {responseType: 'arraybuffer'});
  }
}
